import React from 'react';
import {Link as RouterLink, useHistory} from 'react-router-dom';
import Link from '@mui/material/Link';
import {Container, Grid, Button} from '@mui/material'
import {SectionService} from '../../../services';
import CustomDataGrid  from '../../../customUtil/DataGrid';

const columns = [
    {
        field: 'title', headerName: 'Title', width: 530,
        renderCell: (params) => (
            <Link style={{textDecoration: 'none'}} component={RouterLink} to={'/templates/section/' + params.row.id}>
                {params.value}
            </Link>
        )
    },
    {field: 'sectionOrder', headerName: 'Order', width: 130}
]

const Sections = () => {
        const [list, setList] = React.useState([]);
        const history = useHistory();

        React.useEffect(() => {
            SectionService.getAll()
                .then((response) => setList(response.data));
        }, []);

        return (
            <React.Fragment>
                <Container>
                    <header>
                        <h1>Sections</h1>
                    </header>
                    <Grid container spacing={5}>
                        {/* <Grid item xs={12}>
                        <Button variant='contained' color='primary' onClick={() => {history.push('/templates/section/new')}}>Create New</Button>
                        </Grid> */}
                        <Grid item xs={12}>
                        <CustomDataGrid 
                                rows={list}
                                columns={columns}
                                rowHeight={35}
                               />
                         
                        </Grid>
                    </Grid>
                </Container>
            </React.Fragment>
        );
    }
;

export default Sections;
